import React, { Component, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { History } from 'history';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faFile,
  faWrench,
  faPhone,
  faUser,
  faListOl,
  faUserFriends,
  faEnvelope,
  faBusinessTime,
  faMap,
} from '@fortawesome/free-solid-svg-icons';
import { Navbar } from 'react-bootstrap';
import routes from '../../common/routes';
import { ImpersonationMarker } from './ImpersonationMarker';
import { IAuthState, UserRoles } from '../../redux/modules/auth';
import { withAuth0, WithAuth0Props } from '@auth0/auth0-react';

import headerLogo from '../../images/Fieldata_logo_hvit.png';
import './navbar.scss';
import EventBus from '../../common/EventBus';
import { locale } from '../../common/localization/localizationService';
import { hasRole } from '../../utils/GeneralUtils';

export interface INavBarProps extends WithAuth0Props {
  authentication: IAuthState;
  history: History;
  selectedRoutePage: string;
}

class NavBar extends Component<INavBarProps> {
  private openMenu = () => {
    EventBus.emit('onProfileMenu', { isOpen: true });
  };

  public render(): ReactNode {
    const { name, token, impersonatedUser, auth0Roles } =
      this.props.authentication;
    if (!token) {
      this.props.history.push('/login');
    }

    return (
      <Navbar
        expand="lg"
        variant="dark"
        id="main-navbar"
        className="text-white custom-navbar-height"
      >
        {name && (
          <>
            <Navbar.Brand>
              <img src={headerLogo} className="header-logo" />
            </Navbar.Brand>
            <NavLink
              to={routes.dashboard.base}
              isActive={(_, location) =>
                new RegExp(routes.dashboard.pattern).test(location.pathname)
              }
              className="nav-btn btn btn-outline-light"
            >
              <FontAwesomeIcon icon={faTachometerAlt} />
              <span>{locale.general._dashboard}</span>
            </NavLink>
            {hasRole(auth0Roles, [
              UserRoles.FAGANSVARLIG,
              UserRoles.TRANSPORTMANAGER,
            ]) && (
              <NavLink
                to={routes.orderOveriew}
                isActive={(_, location) =>
                  new RegExp(routes.orderOveriew).test(location.pathname)
                }
                className="nav-btn btn btn-outline-light"
              >
                <FontAwesomeIcon icon={faBusinessTime} />
                <span>{locale.general._orderOverview}</span>
              </NavLink>
            )}
            {hasRole(auth0Roles, [
              UserRoles.DRIFTSLEDER,
              UserRoles.FAGANSVARLIG,
            ]) && (
              <NavLink
                to={routes.smartMap}
                isActive={(_, location) =>
                  new RegExp(routes.smartMap).test(location.pathname)
                }
                className="nav-btn btn btn-outline-light"
              >
                <FontAwesomeIcon icon={faMap} />
                <span>{locale.general._smartMap}</span>
              </NavLink>
            )}
            {hasRole(auth0Roles, [
              UserRoles.FAGANSVARLIG,
              UserRoles.TRANSPORTMANAGER,
            ]) && (
              <NavLink
                to={routes.callordersPath}
                exact
                isActive={(_, location) =>
                  new RegExp(routes.callordersPattern).test(location.pathname)
                }
                className="nav-btn btn btn-outline-light"
              >
                <FontAwesomeIcon icon={faPhone} />
                <span>{locale.general._callOrder}</span>
              </NavLink>
            )}
            {hasRole(auth0Roles, [
              UserRoles.DRIFTSLEDER,
              UserRoles.TRANSPORTMANAGER,
            ]) &&
              !this.props.authentication.isExternalContractor && (
                <NavLink
                  to={routes.serviceListsPath}
                  exact
                  isActive={(_, location) =>
                    new RegExp(routes.serviceListsPattern).test(
                      location.pathname,
                    )
                  }
                  className="nav-btn btn btn-outline-light"
                >
                  <FontAwesomeIcon icon={faWrench} />
                  <span>{locale.general._serviceList}</span>
                </NavLink>
              )}
            {hasRole(auth0Roles, [UserRoles.TRANSPORTMANAGER]) && (
              <NavLink
                to={this.props.selectedRoutePage || routes.routeAdminPagePath}
                isActive={(_, location) => {
                  return (
                    new RegExp(routes.routeAdminPagePattern).test(
                      location.pathname,
                    ) ||
                    new RegExp(routes.autoSequencRoute).test(location.pathname)
                  );
                }}
                className="nav-btn btn btn-outline-light"
              >
                <FontAwesomeIcon icon={faListOl} />
                <span>{locale.general._routeAdmin}</span>
              </NavLink>
            )}
            {!this.props.authentication.isExternalContractor && (
              <NavLink
                to={routes.reportsPath}
                isActive={(_, location) =>
                  new RegExp(routes.reportsPattern).test(location.pathname)
                }
                className="nav-btn btn btn-outline-light navbar-button"
              >
                <FontAwesomeIcon icon={faFile} />
                <span>{locale.general._reports}</span>
              </NavLink>
            )}
            {!this.props.authentication.isExternalContractor && (
              <NavLink
                to={routes.customerSearch}
                isActive={(_, location) =>
                  new RegExp(routes.customerSearch).test(location.pathname)
                }
                className="nav-btn btn btn-outline-light"
              >
                <FontAwesomeIcon icon={faUserFriends} />
                <span>{locale.general._customerRegister}</span>
              </NavLink>
            )}
            {hasRole(auth0Roles || '', [
              UserRoles.DRIFTSLEDER,
              UserRoles.TRANSPORTMANAGER,
            ]) &&
              !this.props.authentication.isExternalContractor && (
                <NavLink
                  to={routes.directMessages}
                  isActive={(_, location) =>
                    new RegExp(routes.directMessages).test(location.pathname)
                  }
                  className="nav-btn btn btn-outline-light navbar-button"
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                  <span>{locale.directMessages._messages}</span>
                </NavLink>
              )}
            <div className="ml-auto d-flex align-items-center user-info-container">
              <div className="user-name-wrapper text-right mr-2">
                <ImpersonationMarker impersonatedUser={impersonatedUser} />
                <div className="user-name-text text-white">{name}</div>
              </div>
              <button
                className="btn btn-light profile-button"
                type="button"
                onClick={this.openMenu}
              >
                <FontAwesomeIcon icon={faUser} />
              </button>
            </div>
          </>
        )}
        {!name && (
          <button
            className="btn btn-light ml-auto profile-button"
            type="button"
            onClick={this.openMenu}
          >
            <FontAwesomeIcon icon={faUser} />
          </button>
        )}
      </Navbar>
    );
  }
}

export default withAuth0(NavBar);
